import {
  jb_video_css_default
} from "./chunk.XLGYWUIY.js";
import {
  Plyr
} from "./chunk.73X4C6NT.js";
import {
  o
} from "./chunk.BLBOUOUQ.js";
import {
  LazyLoadingHandler_default
} from "./chunk.ZXFS3F4J.js";
import {
  e as e2
} from "./chunk.3XLWIJBS.js";
import {
  reset_css_default
} from "./chunk.YAATWOBE.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  Spaceable
} from "./chunk.JI7MO3NT.js";
import {
  debounce
} from "./chunk.JTCOOS2A.js";
import {
  A,
  b,
  i
} from "./chunk.BPIW577J.js";
import {
  e,
  n,
  r,
  r2
} from "./chunk.XW2RSTES.js";
import {
  __decorateClass
} from "./chunk.LUIRGYUH.js";

// src/components/jb-video/jb-video.ts
var JbVideo = class extends Spaceable(i) {
  constructor() {
    super(...arguments);
    this.aspect = "16by9";
    this.preload = "auto";
    this.wide = false;
    this.youtubeCaptionsActive = false;
    this._BREAKPOINT = 600;
    this._captionLanguage = "";
    this._isLarge = false;
    this._observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.intersectionRatio > 0) {
          this._dispatchVisibleEvent();
          if (this._previewVideo) {
            this._previewVideo.play();
          }
          if (this._playing) {
            this._plyr.play();
          }
        } else {
          if (this._previewVideo) {
            this._previewVideo.pause();
          }
        }
      });
    });
    this._playing = false;
    this._progressPercentage = 0;
    this._videopreload = "auto";
    this._youtubeSrc = "";
  }
  connectedCallback() {
    super.connectedCallback();
    this.dispatchEvent(
      new CustomEvent("jb-video:connected", {
        bubbles: true,
        composed: true,
        detail: { element: this }
      })
    );
    this._updateYoutubeCaptionLanguage();
    if (this.src.split(".").pop() !== "mp4") {
      this._buildYoutubeSrc();
    }
    window.addEventListener("resize", debounce(this._windowResized.bind(this), 500));
  }
  updated(changedProperties) {
    super.updated(changedProperties);
    if (changedProperties.has("defaultCaptionsLanguage") || changedProperties.has("youtubeCaptionsLanguageMapping")) {
      this._updateYoutubeCaptionLanguage();
      if (this.src && this.src.split(".").pop() !== "mp4") {
        this._buildYoutubeSrc();
      }
    }
  }
  firstUpdated() {
    const ua = window.navigator.userAgent;
    if (ua.match(/iPhone/i) && this._youtubeSrc !== "") return;
    if (this.preload === "auto") {
      this._videopreload = "none";
      LazyLoadingHandler_default.observe(
        this,
        async () => {
          this._videopreload = "auto";
          this._initPlayer();
          this._initObserver();
        },
        "approachingViewport"
      );
    } else {
      this._videopreload = this.preload;
      this._initPlayer();
      this._initObserver();
    }
  }
  _buildYoutubeSrc() {
    this._youtubeSrc = `https://www.youtube-nocookie.com/embed/${this.src}?rel=0&amp;iv_load_policy=3&amp;modestbranding=0&amp;playsinline=1&amp;enablejsapi=1&amp;color=white
      ${this.autoplay ? "&amp;autoplay=1" : ""}
      ${this.youtubeCaptionsActive ? "&amp;cc_load_policy=1" : ""}
      ${this._youtubeCaptionLanguage ? `&amp;cc_lang_pref=${this._youtubeCaptionLanguage}` : ""}`;
  }
  _dispatchPlayEvent() {
    if (this.isBackground || this._progressPercentage > 0 || this._isVideoGif()) return;
    this.dispatchEvent(
      new CustomEvent("jb-tracking", {
        detail: {
          event: "ce_video",
          event_version: "v2",
          component_name: "video-player",
          file_name: this._videoName,
          file_progress: "start",
          file_type: this._videoExtension
        },
        bubbles: true,
        composed: true
      })
    );
  }
  _dispatchProgressEvent(evt) {
    if (this.isBackground || this._isVideoGif()) return;
    const currentTime = evt.detail.plyr.currentTime || 0;
    const currentDuration = evt.detail.plyr.duration;
    const currentPercentage = currentDuration > 0 ? Math.round(currentTime / currentDuration * 10) * 10 : 0;
    if (currentPercentage > this._progressPercentage) {
      this._progressPercentage = currentPercentage;
      this.dispatchEvent(
        new CustomEvent("jb-tracking", {
          detail: {
            event: "ce_video",
            event_version: "v2",
            component_name: "video-player",
            file_name: this._videoName,
            file_progress: this._progressPercentage + "%",
            file_type: this._videoExtension
          },
          bubbles: true,
          composed: true
        })
      );
    }
  }
  _dispatchVisibleEvent() {
    if (this.isBackground || this._isVideoGif()) return;
    window.setTimeout(() => {
      this.dispatchEvent(
        new CustomEvent("jb-tracking", {
          detail: {
            event: "ce_video",
            event_version: "v2",
            component_name: "video-player",
            file_name: this._videoName,
            file_progress: "visible",
            file_type: this._videoExtension
          },
          bubbles: true,
          composed: true
        })
      );
    }, 0);
  }
  _getContentSpacingProperties() {
    return { grid: true, horizontal: this.wide ? "full-width-xs" : void 0, colsMdUp: this.wide ? 10 : 8 };
  }
  _initObserver() {
    const player = this._videoPlayer ?? this._youtubePlayer;
    this._observer.observe(player);
  }
  _initPlayer(toggle_captions = false, start_time = 0) {
    this.youtubeCaptionsActive = toggle_captions ? !this.youtubeCaptionsActive : this.youtubeCaptionsActive;
    const settings = [];
    let plyrOptions = {
      iconUrl: this.iconPath,
      fullscreen: {
        iosNative: true,
        enabled: true
      },
      playsinline: true,
      disablePictureInPicture: true,
      controls: ["play", "play-large", "progress", "current-time", "mute", "volume", "fullscreen"],
      i18n: {},
      settings,
      muted: this.muted,
      autoplay: this.autoplay || toggle_captions,
      clickToPlay: this.clickToPlay,
      youtube: {
        cc_load_policy: this.youtubeCaptionsActive ? 1 : 0,
        cc_lang_pref: this._youtubeCaptionLanguage
      }
    };
    if (this.captions) {
      plyrOptions.controls.splice(5, 0, "captions", "settings");
      plyrOptions.settings.push("captions");
    }
    if (!this.controls) {
      plyrOptions.controls = [];
    }
    if (this.i18n) {
      plyrOptions = {
        ...plyrOptions,
        i18n: this.i18n
      };
    }
    if (this.isBackground) {
      plyrOptions.controls = [];
      plyrOptions.clickToPlay = false;
      plyrOptions.fullscreen.enabled = false;
      plyrOptions.autoplay = true;
      this._playing = true;
      this.muted = true;
      plyrOptions.muted = true;
      this.loop = true;
    }
    this._plyr = new Plyr(this._videoPlayer, plyrOptions);
    if (this.muted && !this._youtubeSrc) {
      this._videoPlayer.muted = true;
    }
    this._insertGradient(this._plyr.elements.wrapper);
    this._plyr.on("ready", (evt) => {
      const iframe = this._plyr?.elements.container?.querySelector("iframe");
      if (iframe) {
        iframe.tabIndex = -1;
      }
      this._windowResized();
      if (this.previewVideoSrc) {
        this._insertPreviewVideo(evt.detail.plyr.elements.poster);
      }
      if (this.youtubeCaptionsLanguageMapping) {
        const plyrVolume = this._youtubePlayer?.querySelector(".plyr__volume");
        const captionbutton = document.createElement("button");
        captionbutton.innerHTML = `<svg aria-hidden="true" focusable="false"><use xlink:href="${this.iconPath}#plyr-captions-${this.youtubeCaptionsActive ? "on" : "off"}"></use></svg>`;
        captionbutton.setAttribute("id", "caption-button");
        captionbutton.classList.add("plyr__controls__item");
        captionbutton.addEventListener("click", () => {
          this._toggleYoutubeCaptions();
        });
        plyrVolume?.parentNode?.insertBefore(captionbutton, plyrVolume.nextSibling);
      }
      if (toggle_captions) {
        this._plyr.currentTime = start_time;
        this._plyr.muted = false;
      }
    });
    this._plyr.on("timeupdate", this._dispatchProgressEvent.bind(this));
    this._plyr.on("playing", this._dispatchPlayEvent.bind(this));
    this._plyr.on("playing", () => {
      this._playing = true;
    });
    this._plyr.on("pause", () => {
      this._playing = false;
    });
    this._plyr.on("ended", () => {
      this._playing = false;
    });
  }
  _insertGradient(playerWrapper) {
    const gradientElement = document.createElement("div");
    gradientElement.classList.add("gradient");
    playerWrapper.appendChild(gradientElement);
  }
  _insertPreviewVideo(localPlyr) {
    if (this.previewVideoSrc) {
      this._previewVideo = document.createElement("video");
      this._previewVideo.src = this.previewVideoSrc;
      this._previewVideo.muted = true;
      this._previewVideo.autoplay = true;
      this._previewVideo.loop = true;
      localPlyr?.appendChild(this._previewVideo);
      this._plyr.elements.container?.classList.add("plyr__poster-enabled");
    }
    if (this._previewVideo) {
      this._observer.observe(this._previewVideo);
    }
  }
  _isVideoGif() {
    return this.loop && !this.controls && this.muted;
  }
  _languageChanged(e3) {
    this._captionLanguage = e3.detail.plyr.captions.language;
  }
  _renderCaptionTracks() {
    if (this.captions) {
      return this.captions.map(
        (caption) => b`<track
            kind="captions"
            .srclang=${caption.srclang}
            .label=${caption.label}
            .src=${caption.src}
          />`
      );
    }
    return "";
  }
  _renderVideo() {
    return b`
      <div
        class="${e2({
      islarge: this._isLarge,
      videowrapper: true,
      [`aspect-${this.aspect}`]: this.aspect,
      isbackground: !!this.isBackground
    })}"
      >
        ${this._youtubeSrc ? b`
                <div class="${e2({ youtubeplayer: true, background: !!this.isBackground })}">
                  <div class="mainvideo">
                    <iframe
                      .src=${this._youtubeSrc}
                      allowfullscreen
                      allowtransparency
                      allow="autoplay"
                    ></iframe>
                  </div>
                </div>
              ` : b`
                <video
                  class="${e2({ mainvideo: true, background: !!this.isBackground })}"
                  playsinline
                  preload="${this._videopreload}"
                  data-poster="${o(this.poster)}"
                  ?loop=${this.loop}
                  ?autoplay=${this.autoplay}
                  ?muted=${this.muted}
                  @ready=${this._videoReady}
                  @languagechange=${this._languageChanged}
                  @webkitbeginfullscreen=${this._webkitBeginFullScreen}
                  @webkitendfullscreen=${this._webkitEndFullScreen}
                >
                  <source
                    src="${this.src}"
                    type="video/mp4"
                  />
                  ${this._renderCaptionTracks()}
                </video>
              `}
      </div>
    `;
  }
  _setCaptionActive() {
    if (!this.defaultCaptionsLanguage) return;
    if (this._videoPlayerTracks) {
      this._videoPlayerTracks.forEach((track) => {
        if (track.srclang === this.defaultCaptionsLanguage) {
          this._plyr.language = this.defaultCaptionsLanguage;
          this._plyr.toggleCaptions(true);
        }
      });
    }
  }
  _toggleYoutubeCaptions() {
    this._plyr.destroy();
    this._initPlayer(true, this._plyr.currentTime);
  }
  _updateYoutubeCaptionLanguage() {
    if (this.youtubeCaptionsLanguageMapping) {
      const foundKey = Object.keys(this.youtubeCaptionsLanguageMapping).find(
        (key) => key === this.defaultCaptionsLanguage
      );
      this._youtubeCaptionLanguage = foundKey ? this.youtubeCaptionsLanguageMapping[foundKey] : "";
    }
  }
  get _videoExtension() {
    return this._youtubeSrc ? "youtube" : this.src.split(".").pop()?.toLocaleLowerCase();
  }
  get _videoName() {
    return this._youtubeSrc ? this._plyr.config.title + " (" + this.src + ")" : this.src.split("/").pop();
  }
  _videoReady() {
    this._setCaptionActive();
  }
  _webkitBeginFullScreen() {
    document.documentElement.style.setProperty("--webkit-text-track-display", "block");
    if (this._captionLanguage) {
      let trackUid = 0;
      if (this._videoPlayerTracks) {
        this._videoPlayerTracks.forEach((track, index) => {
          if (track.srclang === this._captionLanguage) {
            trackUid = index;
          }
        });
        this._videoPlayer.textTracks[trackUid].mode = "showing";
      }
    }
  }
  _webkitEndFullScreen() {
    document.documentElement.style.setProperty("--webkit-text-track-display", "none");
    if (this._captionLanguage) {
      let trackUid = 0;
      if (this._videoPlayerTracks) {
        this._videoPlayerTracks.forEach((track, index) => {
          if (track.srclang === this._captionLanguage) {
            trackUid = index;
          }
        });
        this._videoPlayer.textTracks[trackUid].mode = "disabled";
      }
    }
  }
  _windowResized() {
    this._isLarge = this.offsetWidth >= this._BREAKPOINT;
  }
  render() {
    return this.caption || this.text || this.credit ? b`
          <section class="${e2({ islarge: this._isLarge })}">
            <div class="videocontainer">
              ${this._renderVideo()} ${this.caption ? b`<p class="caption">${this.caption}</p>` : A}
            </div>
            ${this.text ? b`<p class="text">${this.text}</p>` : A}
            ${this.credit ? b`<p class="credit">${this.credit}</p>` : A}
          </section>
        ` : this._renderVideo();
  }
};
JbVideo.styles = [reset_css_default, jb_video_css_default];
__decorateClass([
  n()
], JbVideo.prototype, "aspect", 2);
__decorateClass([
  n({ type: Boolean })
], JbVideo.prototype, "autoplay", 2);
__decorateClass([
  n()
], JbVideo.prototype, "caption", 2);
__decorateClass([
  n({ type: Array })
], JbVideo.prototype, "captions", 2);
__decorateClass([
  n({ type: Boolean })
], JbVideo.prototype, "clickToPlay", 2);
__decorateClass([
  n({ type: Boolean })
], JbVideo.prototype, "controls", 2);
__decorateClass([
  n()
], JbVideo.prototype, "credit", 2);
__decorateClass([
  n()
], JbVideo.prototype, "defaultCaptionsLanguage", 2);
__decorateClass([
  n({ type: Object })
], JbVideo.prototype, "i18n", 2);
__decorateClass([
  n()
], JbVideo.prototype, "iconPath", 2);
__decorateClass([
  n({ type: Boolean })
], JbVideo.prototype, "isBackground", 2);
__decorateClass([
  n({ type: Boolean })
], JbVideo.prototype, "loop", 2);
__decorateClass([
  n({ type: Boolean })
], JbVideo.prototype, "muted", 2);
__decorateClass([
  n()
], JbVideo.prototype, "poster", 2);
__decorateClass([
  n()
], JbVideo.prototype, "preload", 2);
__decorateClass([
  n()
], JbVideo.prototype, "previewVideoSrc", 2);
__decorateClass([
  n()
], JbVideo.prototype, "src", 2);
__decorateClass([
  n()
], JbVideo.prototype, "text", 2);
__decorateClass([
  n({ type: Boolean })
], JbVideo.prototype, "wide", 2);
__decorateClass([
  n({ type: Boolean })
], JbVideo.prototype, "youtubeCaptionsActive", 2);
__decorateClass([
  n({ type: Object })
], JbVideo.prototype, "youtubeCaptionsLanguageMapping", 2);
__decorateClass([
  r()
], JbVideo.prototype, "_isLarge", 2);
__decorateClass([
  r()
], JbVideo.prototype, "_playing", 2);
__decorateClass([
  r()
], JbVideo.prototype, "_progressPercentage", 2);
__decorateClass([
  e(".mainvideo")
], JbVideo.prototype, "_videoPlayer", 2);
__decorateClass([
  r2("track")
], JbVideo.prototype, "_videoPlayerTracks", 2);
__decorateClass([
  r()
], JbVideo.prototype, "_videopreload", 2);
__decorateClass([
  e(".youtubeplayer")
], JbVideo.prototype, "_youtubePlayer", 2);
__decorateClass([
  r()
], JbVideo.prototype, "_youtubeSrc", 2);
JbVideo = __decorateClass([
  customElement("jb-video")
], JbVideo);

export {
  JbVideo
};
